<template>
    <div class="sa-pai-domiciliare-container">
        <b-row class="mb-4 align-items-center">
            <b-col md="12" class="d-flex justify-content-between align-items-center">
                <div style="width: 350px">
                    <b-input-group class="sa-pai-domiciliare-search-group">
                        <b-input-group-prepend is-text>
                            <i class="fas fa-search"></i>
                        </b-input-group-prepend>
                        <b-form-input v-model="filtro" placeholder="Cerca paziente o codice PAI..." @input="onSearch"></b-form-input>
                    </b-input-group>
                </div>

                <b-button v-if="!isRiepilogoPai" variant="success" class="sa-pai-domiciliare-btn-new px-3 shadow-sm" @click="onClickNuovoPaiDomiciliare()"> <i class="fas fa-plus-circle mr-1"></i> Nuovo P.A.I. </b-button>
            </b-col>
        </b-row>

        <b-row v-if="itemsFiltrati.length > 0" :key="key">
            <b-col v-for="pai in itemsFiltrati" :key="pai.id" xl="4" lg="6" md="6" class="mb-4">
                <b-card no-body class="sa-pai-domiciliare-card">
                    <div :class="['sa-pai-domiciliare-status-bar', getStatusClass(pai.statoAttuale)]"></div>

                    <b-card-body class="sa-pai-domiciliare-card-body">
                        <div class="d-flex justify-content-between align-items-start mb-2">
                            <h5 v-if="isRiepilogoPai">
                                <strong>{{ pai.nome }} {{ pai.cognome }}</strong>
                            </h5>
                            <span class="sa-pai-domiciliare-id-badge"> </span>
                            <b-dropdown variant="link" no-caret right size="sm">
                                <template #button-content>
                                    <i class="fas fa-ellipsis-v text-muted"></i>
                                </template>
                                <b-dropdown-item @click="onClickModificaPai(pai)"> <i class="fas fa-edit mr-2"></i>Modifica </b-dropdown-item>
                                <b-dropdown-item @click="$emit('print', pai)"> <i class="fas fa-print mr-2"></i>Stampa </b-dropdown-item>
                            </b-dropdown>
                        </div>

                        <h5 class="sa-pai-domiciliare-patient-name">{{ pai.statoAttuale }}</h5>

                        <div class="sa-pai-domiciliare-info-section">
                            <b-row class="mb-3">
                                <b-col cols="6">
                                    <label class="sa-pai-domiciliare-meta-label">Data Attivazione</label>
                                    <div class="sa-pai-domiciliare-meta-value text-nowrap"><i class="far fa-calendar-alt mr-1"></i> {{ formatDate(pai.dataPrimaAttivazione) }}</div>
                                </b-col>
                                <b-col cols="6">
                                    <label class="sa-pai-domiciliare-meta-label">Accessi Totali</label>
                                    <div class="sa-pai-domiciliare-meta-value"><i class="fas fa-user-md mr-1"></i> {{ getNumeroAccessi(pai) }}</div>
                                </b-col>
                            </b-row>
                            <div>
                                <label class="sa-pai-domiciliare-meta-label">Diagnosi</label>
                                <p class="sa-pai-domiciliare-diagnosi-preview">
                                    {{ pai.diagnosi || "Nessuna diagnosi inserita." }}
                                </p>
                            </div>
                        </div>

                        <div class="sa-pai-domiciliare-card-footer">
                            <span class="sa-pai-domiciliare-update-text"> Aggiornato: {{ formatDate(pai.updateDate) }} </span>
                            <b-button variant="outline-primary" size="sm" pill @click="$emit('open-detail', pai)"> Gestisci <i class="fas fa-chevron-right ml-1"></i> </b-button>
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>

        <div v-else class="sa-pai-domiciliare-empty-state text-center">
            <i class="fas fa-folder-open fa-3x mb-3"></i>
            <p>Nessun Piano Assistenziale trovato.</p>
        </div>
        <rsa-paziente-pai-domiciliare-edit-modal-component ref="mdlRsaPazientePaiDomiciliareEditModalComponent" @afterCloseModal="onAfterCloseModal"></rsa-paziente-pai-domiciliare-edit-modal-component>
    </div>
</template>
<script>
import RsaPazientePaiDomiciliareEditModalComponent from "./RsaPazientePaiDomiciliareEditModalComponent.vue";
import RsaPaiDomiciliareMixin from "../mixins/RsaPaiDomiciliareMixin";
export default {
    name: "RsaPaiListaMasterComponent",
    components: { RsaPazientePaiDomiciliareEditModalComponent },
    mixins: [RsaPaiDomiciliareMixin],
    data() {
        return {
            items: [],
            filtro: "",
            jsonDataAccettazioe: {},
            filtroPai: {},
            key: 0,
            isRiepilogoPai: false,
        };
    },
    computed: {
        itemsFiltrati() {
            if (!this.filtro) return this.items;
            const s = this.filtro.toLowerCase();
            return this.items.filter((pai) => (pai.id && pai.id.toLowerCase().includes(s)) || (pai.nome && pai.nome.toLowerCase().includes(s)) || (pai.cognome && pai.cognome.toLowerCase().includes(s)));
        },
    },
    methods: {
        init(jsonDataAccettazioe) {
            let me = this;
            me.jsonDataAccettazioe = jsonDataAccettazioe;
            me.loadData();
        },
        initRiepilogo() {
            let me = this;
            me.isRiepilogoPai = true;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.filtroPai = { idAccettazione: me.jsonDataAccettazioe.id };
            me.listaPaiDomiciliareLoadData(me.filtroPai, me.afterLoadData);
        },
        afterLoadData() {
            let me = this;
            me.items = me.listaPaiDomiciliare;

            me.$emit("afterLoadData", me.items);
            me.key++;
        },
        formatDate(value) {
            if (!value) return "-";
            const date = new Date(isNaN(value) ? value : parseInt(value));
            return date.toLocaleDateString("it-IT");
        },
        getStatusClass(stato) {
            return {
                "sa-pai-domiciliare-status-active": stato === "ATTIVO",
                "sa-pai-domiciliare-status-warning": stato === "SCADENZA",
                "sa-pai-domiciliare-status-closed": stato === "CHIUSO",
            };
        },
        onSearch() {
            this.$emit("search", this.filtro);
        },
        getNumeroAccessi(pai) {
            return pai.listaAccessi.length;
        },
        onClickNuovoPaiDomiciliare() {
            this.$refs.mdlRsaPazientePaiDomiciliareEditModalComponent.show(this.jsonDataAccettazioe.id);
        },
        onClickModificaPai(pai) {
            let me = this;
            me.$refs.mdlRsaPazientePaiDomiciliareEditModalComponent.showModificaPai(pai.id);
        },

        onAfterCloseModal() {
            let me = this;
            me.loadData();
        },
    },
};
</script>

<style scoped>
.sa-pai-domiciliare-container {
    padding: 10px;
    height: 100%;
    overflow: auto;
}

.sa-pai-domiciliare-search-group {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.sa-pai-domiciliare-card {
    border: 1px solid #e3e6f0;
    border-radius: 10px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    overflow: hidden;
    height: 100%;
}

.sa-pai-domiciliare-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1) !important;
}

.sa-pai-domiciliare-status-bar {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 6px;
}

.sa-pai-domiciliare-status-active {
    background-color: #28a745;
}

.sa-pai-domiciliare-status-warning {
    background-color: #f6c23e;
}

.sa-pai-domiciliare-status-closed {
    background-color: #858796;
}

.sa-pai-domiciliare-card-body {
    /* Spazio per la barra di stato */
    display: flex;
    flex-direction: column;
    padding: 1.25rem;
    padding-left: 1.75rem;
    /* Spazio per la barra di stato */
    display: flex;
    flex-direction: column;
}

.sa-pai-domiciliare-id-badge {
    font-size: 0.75rem;
    color: #aeb1be;
    font-weight: bold;
    text-transform: uppercase;
}

.sa-pai-domiciliare-patient-name {
    color: #4e73df;
    font-weight: 700;
    margin-bottom: 1rem;
}

.sa-pai-domiciliare-meta-label {
    display: block;
    font-size: 0.85rem;
    text-transform: uppercase;
    color: #999;
    font-weight: bold;
    letter-spacing: 1px;
}

.sa-pai-domiciliare-meta-value {
    font-weight: 600;
    font-size: 0.9rem;
    color: #333;
}

.sa-pai-domiciliare-diagnosi-preview {
    font-size: 1.05rem;
    color: #666;
    display: -webkit-box;
    /*-webkit-line-clamp: 3;*/
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-top: 5px;
    line-height: 1.4;
}

.sa-pai-domiciliare-card-footer {
    margin-top: auto;
    padding-top: 1rem;
    border-top: 1px solid #f1f1f1;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.sa-pai-domiciliare-update-text {
    font-size: 0.95rem;
    color: #aaa;
    font-style: italic;
}

.sa-pai-domiciliare-empty-state {
    padding: 3rem;
    color: #8a8a8a;
    background: #f0f0f0;
    border-radius: 10px;
    border: 2px dashed #b3b3b3;
}
</style>
